/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AssetManagerIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="AssetManagerIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <g>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.00003 6.00002C4.00003 5.44773 4.44775 5.00002 5.00003 5.00002H14C14.5523 5.00002 15 5.44773 15 6.00002V13C15 13.5523 14.5523 14 14 14H5.00003C4.44775 14 4.00003 13.5523 4.00003 13V6.00002ZM14 6.00002H5.00003V13H14V6.00002Z"
                fill="currentColor"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.75 9.04291L14.8536 13.1465L14.1465 13.8536L10.75 10.4571L7.35358 13.8536L6.64648 13.1465L10.75 9.04291Z"
                fill="currentColor"
              />
              <path
                d="M8.00003 9.00002C8.00003 9.5523 7.55232 10 7.00003 10C6.44775 10 6.00003 9.5523 6.00003 9.00002C6.00003 8.44773 6.44775 8.00002 7.00003 8.00002C7.55232 8.00002 8.00003 8.44773 8.00003 9.00002Z"
                fill="currentColor"
              />
              <path
                d="M1.30418 2.97956C0.760286 3.07546 0.397117 3.59412 0.493021 4.13802L1.70856 11.0317C1.80446 11.5756 2.32312 11.9387 2.86701 11.8428L3.00003 11.8194V10.8039L2.69337 10.858L1.47783 3.96437L10.3411 2.40153L10.623 4.00003H11.6384L11.3259 2.22789C11.23 1.68399 10.7113 1.32082 10.1674 1.41673L1.30418 2.97956Z"
                fill="currentColor"
              />
            </g>
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

AssetManagerIcon.tags = [
  'photo',
  'picture',
  'gallery',
  'images',
  'album',
  'media',
];

AssetManagerIcon.category = 'General Icons';

AssetManagerIcon.iconSize = 16;
